
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/helicopter-tours",
      function () {
        return require("private-next-pages/concierge/helicopter-tours.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/helicopter-tours"])
      });
    }
  